import React from 'react';
import { Container, Label, PasswordField, Spacer, Button, FormPanel } from '@sencha/ext-modern';
import { doChangePassword } from 'tyan/reducers/actions'
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as utility from '../public';

class ChangePassword extends React.Component {
    state = {
        setSuccess: false,
        errorMessage: null,
        submitting: null,
        formData: {
            oldPassword: '',
            newPassword: '',
            checkPassword: '',
        }
    }

    handleBack = () => {
        this.props.history.push('/')
    }
    handleKeyPress = () => {
        this.handleSubmit()
    }

    handleInput = (obj, value) => {
        const { formData } = this.state
        const name = obj.getName()
        const newFormData = { [name]: value }
        const { newPassword, checkPassword, oldPassword } = { ...formData, ...newFormData }
        // const errorMessage = (name === "newPassword" && !utility.validatePassword(newPassword) || name === "checkPassword" && !utility.validatePassword(checkPassword)) ? `密码不符合规范` :
        //     (checkPassword === newPassword ? (newPassword === oldPassword ? "新旧密码不能完全相同" : "") : "两次密码输入不一致")
        const errorMessage = (name === "newPassword" && !newPassword || name === "checkPassword" && !checkPassword) ? `密码不符合规范` :
            (checkPassword === newPassword ? (newPassword === oldPassword ? "新旧密码不能完全相同" : "") : "两次密码输入不一致")
        this.setState({ formData: { ...formData, ...newFormData }, errorMessage })
    }

    handleSubmit = () => {
        const { submitting, formData: { newPassword, oldPassword, checkPassword }, errorMessage } = this.state
        const { doChangePassword } = this.props
        if (!oldPassword) {
            this.setState({ errorMessage: "旧密码不能为空" })
            return
        } else if (!newPassword) {
            this.setState({ errorMessage: "新密码不能为空" })
            return
        } else if (!checkPassword) {
            this.setState({ errorMessage: "请重复输入新密码" })
            return
        }
        if (submitting || errorMessage)
            return

        doChangePassword({
            oldPassword, newPassword,
            onRequest: () => {
                this.setState({ submitting: true })
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    this.setState({ submitting: false, errorMessage })
                } else {
                    this.setState({ submitting: false, setSuccess: true })
                }
            }
        })
    }

    render() {
        const { setSuccess, errorMessage, submitting } = this.state
        return (

            <Container margin="5 0 0 10"
                platformConfig={{
                    phone: {
                        layout: 'fit'
                    },
                    "!phone": {
                        layout: 'vbox'
                    }
                }}
            >
                <FormPanel
                    shadow
                    padding="20"
                    title={`修改密码`}
                    iconCls="x-fa fa-key"
                    ui="light"
                    platformConfig={{
                        "!phone": {
                            maxHeight: 500,
                            width: 350,
                        }
                    }}
                >
                    <Label html={!setSuccess ? "请设置您的新密码，密码长度应不少于6位，并同时包括大写字符、小写字符和数字。" : "密码修改成功！"} />
                    {!setSuccess && <PasswordField label="旧密码"
                        name="oldPassword"
                        labelAlign="top"
                        required
                        placeholder="请输入旧密码"
                        requiredMessage="请输入旧密码"
                        onAction={this.handleKeyPress}
                        onChange={this.handleInput} />}
                    {!setSuccess && <PasswordField label="新密码"
                        name="newPassword"
                        labelAlign="top"
                        required
                        placeholder="请输入新密码"
                        requiredMessage="请输入新密码"
                        onAction={this.handleKeyPress}
                        onChange={this.handleInput} />}
                    {!setSuccess && <PasswordField label="重复新密码"
                        name="checkPassword"
                        labelAlign="top"
                        required
                        placeholder="请再次输入新密码"
                        requiredMessage="请再次输入新密码"
                        onAction={this.handleKeyPress}
                        onChange={this.handleInput} />}
                    {errorMessage ? <Label html={errorMessage} style={{ color: 'red' }} /> : <Spacer height="20" />}
                    <Spacer height="20" />
                    <Button
                        ui="action raised"
                        iconCls={submitting && "x-fa fa-spinner fa-pulse" || setSuccess && "x-fa fa-arrow-left" || "x-fa fa-floppy-o"}
                        text={setSuccess ? "返回" : "保存"}
                        width='100%'
                        handler={setSuccess ? this.handleBack : this.handleSubmit}
                    />
                </FormPanel>
            </Container>
        )
    }
}


export default compose(
    connect(null, { doChangePassword }),
)(ChangePassword)
